import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { TaskDto } from "../../entities/processCycle/TaskDto";
import { AppDispatch } from "../../store/configureStore";
import { approveJobOffer, rejectTask } from "../../store/slices/candidateProcesses";
import { useAddComment } from "../UI/AddCommentComponent";
import FileDownloadButton from "../UI/FileDownloadButton";
import { getFileNameFromBlobUrl } from "../UI/FileDownloadComponent";
import { LinkItemDto } from "../../entities/processCycle/LinkItemDto";

interface Props {
    task: TaskDto,
}

function JobOfferCard({ task }: Props) {
    const { t } = useTranslation("candidate_portal");
    const dispatch = useDispatch<AppDispatch>();
    const { showAddComment, AddCommentComponent } = useAddComment();

    const TASK_STATUS_REJECTED = 2;
    const TASK_STATUS_COMPLETED = 1;
    const CANDIDATE_STATUS_AGREED = 3;

    const isRejected = task.Status === TASK_STATUS_REJECTED;
    const isAgreed = task.CandidateTaskStatusId === CANDIDATE_STATUS_AGREED || task.Status === TASK_STATUS_COMPLETED;
    const isActionable = !isRejected && !isAgreed;

    const handleReject = async () => {
        const comment = await showAddComment(t("jobOffer.commentTitle"));
        if (comment) {
            dispatch(rejectTask(task.Id, comment));
        }
    };

    const handleApprove = () => {
        dispatch(approveJobOffer(task.Id));
    }

    const mainLink = task.Link || "";
    const mainLinkId = task.LinkId || 0;
    const hasLink = !!mainLink;

    return (
        <>
            {hasLink && (
                <FileDownloadButton
                    fileName={getFileNameFromBlobUrl(mainLink)}
                    fileRefId={mainLinkId}
                    disabled={!hasLink}
                    classNameBtn="big circular-button edit-button outline-none p-0"
                    onChange={(success, error) =>
                        console.log("fileDownload", success, error)
                    }
                    className="main-file-download-button"
                />
            )}

            {hasLink && (
                <div>
                    <FileDownloadButton
                        fileName={getFileNameFromBlobUrl(mainLink)}
                        fileRefId={mainLinkId}
                        disabled={!hasLink}
                        classNameBtn="btn border-0 p-0 active-color font-input-full"
                        onChange={(success, error) =>
                            console.log("fileDownload", success, error)
                        }
                        className="mb-2"
                        icon={
                            <div>{getFileNameFromBlobUrl(mainLink)}</div>
                        }
                    />
                </div>
            )}

            {((task.Files && task.Files.length > 0) || (task.Links && task.Links.length > 0)) ? (
                <div>
                    <div className="card-subtitle mb-2">{t("contract.documents")}</div>
                    {
                        task.Files && task.Files.length > 0 && task.Files.map((link: LinkItemDto, index: number) => (
                            <FileDownloadButton
                                key={link.Id}
                                fileName={link.Url}
                                fileRefId={link.Id}
                                classNameBtn="btn border-0 p-0 active-color font-input-full"
                                onChange={(success, error) =>
                                    console.log("fileDownload", success, error)
                                }
                                className="mb-1"
                                icon={
                                    <div>{link.Text}</div>
                                }
                            />
                        ))
                    }
                    {
                        task.Links && task.Links.length > 0 && task.Links.map((link: LinkItemDto, index: number) => (
                            <a
                                key={link.Id}
                                href={link.Url}
                                download={link.Text}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mb-1 btn border-0 p-0 active-color font-input-full"
                            >
                                <div>{link.Text}</div>
                            </a>
                        ))
                    }
                </div>
            ) : null}

            {isActionable && (<div>
                <Button variant="primary" onClick={handleApprove} className="visual-selection-aid">
                    {t("jobOffer.agree")}
                </Button>
                <Button variant="outline-active" className="ms-5 visual-selection-aid" onClick={handleReject}>
                    {t("jobOffer.disagree")}
                </Button>
            </div>)}

            {isAgreed && (
                <div className="mt-3 p-3 bg-light">
                    <strong>✓ {t("jobOffer.agreeStatus")}</strong>
                    {task.SenderComment && (<div className="mt-2 small">{task.SenderComment}</div>)}
                </div>
            )}
            {isRejected && (
                <div>
                    <strong>✗ {t("jobOffer.rejectStatus")}</strong>
                    {task.SenderComment && (<div className="mt-2 small">{t("reason")}: {task.SenderComment}</div>)}
                </div>
            )}

            <AddCommentComponent />
        </>
    );
}

export default JobOfferCard;